import { formatCurrency } from '@chikara/utils';

export const formatMXN = (value: number) => formatCurrency(value, { locale: 'es-MX', currency: 'MXN' });

// Helper para formatear fecha como "Dic 03 2024, 02:33 PM"
export const formatDashboardDate = (date: Date | string, withHours: boolean = true): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
  const month = months[d.getMonth()];
  const day = d.getDate().toString().padStart(2, '0');
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = d.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 should be 12
  const hoursStr = hours.toString().padStart(2, '0');

  return withHours ? `${month} ${day} ${year}, ${hoursStr}:${minutes} ${ampm}` : `${month} ${day} ${year}`;
};
